import React from 'react';
import { LanguageSwitcher, useI18n } from '../i18n';
import type { MsgKey } from '../i18n/en';

/**
 * The tracker's frame, dressed as the store's: the same glass header with the
 * wordmark, and a slimmed version of the store's footer. Every customer page
 * uses these so the tracker reads as a room in the shop, not a separate site.
 */

export const STORE_URL = 'https://911gamingstore.com';

/** Tags a store link so the store's analytics can tell tracker traffic apart. */
export const storeLink = (path = '/', campaign = 'tracker') => {
  const sep = path.includes('?') ? '&' : '?';
  return `${STORE_URL}${path}${sep}utm_source=tracker&utm_medium=order-page&utm_campaign=${campaign}`;
};

interface HeaderProps {
  /** The small pill on the right — "Order Tracker", "Robux Order". */
  badge: MsgKey;
}

export const SiteHeader: React.FC<HeaderProps> = ({ badge }) => {
  const { t } = useI18n();
  return (
    <nav className="tc-nav">
      <div className="tc-nav-inner">
        <a className="tc-nav-brand" href="/" aria-label="911 Gaming Store tracker">
          <img src="/logo.png" alt="911 Gaming Store" className="tc-nav-logo" />
          <span className="tc-nav-name">{t(badge)}</span>
        </a>
        <span className="tc-nav-right">
          <LanguageSwitcher />
        </span>
      </div>
    </nav>
  );
};

export const SiteFooter: React.FC = () => {
  const { t } = useI18n();
  return (
    <footer className="tc-footer">
      <div className="tc-footer-inner">
        <div className="tc-footer-main">
          <div className="tc-footer-brand">
            <img src="/logo.png" alt="911 Gaming Store" className="tc-footer-logo" />
            <p className="tc-footer-desc">{t('footer.desc')}</p>
          </div>

          <div className="tc-footer-col">
            <h5>{t('footer.help')}</h5>
            <a href="/">{t('footer.track')}</a>
          </div>

          <div className="tc-footer-col">
            <h5>{t('shop.pay')}</h5>
            <div className="tc-footer-pay">
              {['USDT', 'BTC', 'ETH', 'BNB', 'SOL', 'XRP'].map(c => <span key={c}>{c}</span>)}
            </div>
          </div>
        </div>
        <div className="tc-footer-bar">
          © {new Date().getFullYear()} 911 Gaming Store
        </div>
      </div>
    </footer>
  );
};
